
import React, { useRef, useState } from "react";
import Slider from "react-slick";

const AboutTimeline = () => {
  const sliderRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const timelineData = [
    {
      year: "1990",
      image: "/assets/images/history-image-new1.webp",
      text: "Inception of Supershine Laundry Systems. Began collaborating with leading OEMs across the globe.",
    },
    {
      year: "1992",
      image:  "/assets/images/history-image-new2.webp",
      text: "First international exposure with entry into Nepal.",
    },
    {
      year: "1993",
      image: "/assets/images/history-image-new3.webp",
      text: "Established our manufacturing facility.",
    },
    {
      year: "2004",
      image:
        "/assets/images/history-image-new4.webp",
      text: "Reached a milestone of 1,000 clients.",
    },
    {
      year: "2012",
      image:  "/assets/images/history-image-new5.webp",
      text: "Diversified into the Railway segment.",
    },
    {
      year: "2013",
      image:  "/assets/images/history-image-new6.webp",
      text: "Delivered India's largest laundry plant: Central Linen Park Pvt. Ltd., Bhiwadi.",
    },
    {
      year: "2015",
      image:
        "/assets/images/history-image-new7.webp",
      text: "Celebrated our Silver Jubilee — 25 years of operations.",
    },

    
      {
      year: "2019",
      image:"/assets/images/history-image-new8.webp",
      text: "Supershine Hospitality Solutions Private Limited was formally incorporated, marking the establishment of the company as a registered legal entity.",
    },

    {
      year: "2023",
      image:
        "/assets/images/history-image-new9.webp",
      text: "Reached 4,000 clients.",
    },



      {
      year: "2025",
      image:"/assets/images/history-image-new10.webp",
      text: "Opened offices in Dubai and Africa, marking our global expansion.",
    },
  ];

   const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    adaptiveHeight: true,

    beforeChange: (current, next) => {
      setActiveSlide(next);
    },
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
            verticalSwiping: false,
             adaptiveHeight: false,
        },
      }
    ],
  };

  return (
    <>
      <section className="about-timeline">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="about-timeline-head">
              <span className="gradient-color">Our History</span>
              <h3 className="heading center-heading">Our Journey Through the Years</h3>
            </div>
          </div>
          <div className="col-lg-12">
            <Slider ref={sliderRef} {...settings} className="about-timeline-slide"  >
              {timelineData.map((item, index) => (
                <div key={index}>
                  <div className="about-timeline-details">
                    <img src={item.image} alt={`timeline-${item.year}`} className="img-responsive" />
                    <p>{item.text}</p>
                    <span>{item.year}</span>
                  </div>
                </div>
              ))}
            </Slider>
          
           <div className="timeline-navigation">
              <div className="timeline-line"></div>
              {timelineData.map((item, index) => (
                <div   key={index}  className="timeline-item"
                  onClick={() => {  sliderRef.current.slickGoTo(index);  setActiveSlide(index);  }} >
                  <span  className={`timeline-dot ${    activeSlide === index ? "active" : "" }`}  >  {activeSlide === index && item.year}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  
  );
};

export default AboutTimeline;